module.exports = __webpack_public_path__ + "img/D202307_23.c500aafd.jpg";